import {JSX, forwardRef} from 'react'
import classNames from 'classnames'
import styles from './SearchTextBox.scss'

export type SearchTextBoxProps = JSX.IntrinsicElements['input'] & {
  isError?: boolean
}

export const SearchTextBox = forwardRef<HTMLInputElement, SearchTextBoxProps>(
  ({type = 'text', isError = false, ...props}, ref) => {
    return (
      <div className={classNames(styles.searchTextBox, isError && styles.searchTextBoxError)}>
        <input ref={ref} type={type} {...props} />
      </div>
    )
  }
)

SearchTextBox.displayName = 'SearchTextBox'
